import { useParams } from 'react-router-dom';

import { Server1Wizard } from './wizards/Server1Wizard';
import { Server2Wizard } from './wizards/Server2Wizard';
import { Server3Wizard } from './wizards/Server3Wizard';

export function PurchaseProxyWizard() {
  const { serverId } = useParams<{ serverId: string }>();
  const serverIdNum = Number(serverId);

  switch (serverIdNum) {
    case 1:
      return <Server1Wizard />;
    case 2:
      return <Server2Wizard />;
    case 3:
      return <Server3Wizard />;
    default:
      return (
        <div className="text-center py-12">
          <p className="text-neutral-medium font-body">Invalid server ID</p>
        </div>
      );
  }
}

